const STORAGE_PREFIX = "ccc_clue_collapsed_v1";

export function collapsedClueStorageKey(sessionId: string, userId: string): string {
  return `${STORAGE_PREFIX}:${sessionId}:${userId}`;
}

export function readCollapsedClueIds(sessionId: string, userId: string): Set<string> {
  if (!sessionId || !userId) return new Set();
  try {
    const raw = localStorage.getItem(collapsedClueStorageKey(sessionId, userId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((id): id is string => typeof id === "string" && id.length > 0));
  } catch {
    return new Set();
  }
}

function writeCollapsedClueIds(sessionId: string, userId: string, ids: Set<string>): void {
  if (!sessionId || !userId) return;
  try {
    localStorage.setItem(collapsedClueStorageKey(sessionId, userId), JSON.stringify([...ids]));
  } catch {
    /* ignore quota */
  }
}

export function setClueCollapsed(
  sessionId: string,
  userId: string,
  clueId: string,
  collapsed: boolean
): void {
  const ids = readCollapsedClueIds(sessionId, userId);
  if (collapsed) ids.add(clueId);
  else ids.delete(clueId);
  writeCollapsedClueIds(sessionId, userId, ids);
}

export function isClueCollapsed(
  sessionId: string,
  userId: string,
  clueId: string
): boolean {
  return readCollapsedClueIds(sessionId, userId).has(clueId);
}
